// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oi-1";
export var messageSideRight = "_oi-2";
export var orderLookupBubbleContainer = "_oi-0";
export var submitButton = "_oi-3";